import { appStore } from "../state/store";
import { ProgressBar } from "./ProgressBar";
export class CoreProjects {
    constructor(app) {
        this.app = app;
        this.progressBar = new ProgressBar(7, 7);
    }
    // Helper function to measure text width accurately using Canvas API
    measureTextWidth(text, font = '16px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif') {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (context) {
            context.font = font;
            const metrics = context.measureText(text);
            // Add buffer for padding (assuming 0.5rem ~8px on each side, so +16px) and borders (+4px)
            return Math.max(Math.ceil(metrics.width) + 32 + 4, 150); // Min 150px to prevent too narrow
        }
        // Fallback to length-based if canvas unavailable (e.g., server-side render)
        return Math.max(text.length * 15 + 40, 150);
    }
    // Post-render adjustment for pixel-perfect sizing (run after form is in DOM)
    adjustProjectWidths() {
        const nameInputs = document.querySelectorAll('.project-input-name');
        nameInputs.forEach((input) => {
            const entry = input.closest('.project-entry');
            if (entry && input instanceof HTMLInputElement) {
                // Temporarily set input to auto width to measure natural size
                const originalWidth = input.style.width;
                input.style.width = 'auto';
                const naturalWidth = input.getBoundingClientRect().width;
                input.style.width = originalWidth;
                // Update entry width (add buffer for h4, gaps, padding ~40px)
                const entryWidth = Math.max(naturalWidth + 50, 150);
                entry.style.width = `${entryWidth}px`;
            }
        });
    }
    render() {
        // Read initial projects from the store to dynamically build the form.
        const initialProjects = appStore.getState().user.onboardingInputs.personalProjects || [];
        // Compute accurate widths for each project name using Canvas (or fallback)
        const nameWidths = initialProjects.map(project => {
            return this.measureTextWidth(project.name || '');
        });
        const projectsHtml = initialProjects.map((project, index) => {
            const estimatedWidth = nameWidths[index];
            return `
                <div class="project-entry" data-project-index="${index + 1}" style="width: ${estimatedWidth}px; min-width: 150px;">
                    <h4>Project ${index + 1}</h4>
                    <input type="text" id="project-${index + 1}-name" class="project-input-name" value="${project.name || ''}" required style="width: 100%; box-sizing: border-box;">
                    <input type="date" id="project-${index + 1}-deadline" class="project-input-deadline" value="${project.deadline || ''}" style="width: 100%; box-sizing: border-box;">
                    <input type="text" id="project-${index + 1}-goal" class="project-input-goal" placeholder="Measured Goal (e.g., 12 chapters)" value="${project.measuredGoal || ''}" style="width: 100%; box-sizing: border-box;">
                </div>
            `;
        }).join('');
        return `
            <div class="card">
                ${this.progressBar.render()}
                <h2>Step 5: Your Core Personal Projects</h2>
                <p>Finally, let's connect your values to your work. List your most important current projects. These are the primary <strong>Entities</strong> where your values will be expressed.</p>
                <form id="projects-form" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 1.5rem; align-items: flex-start; justify-content: flex-start;">
                    ${projectsHtml}
                    <div class="button-container" style="flex: 0 0 auto; margin-top: auto; align-self: flex-start;">
                        <button type="submit" class="button-primary">Complete Onboarding</button>
                    </div>
                </form>
            </div>
        `;
    }
    attachEventListeners() {
        var _a;
        // Adjust widths post-render for precision (assumes DOM is updated after render)
        requestAnimationFrame(() => {
            this.adjustProjectWidths();
        });
        (_a = document.getElementById('projects-form')) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', (e) => {
            e.preventDefault();
            const projects = [];
            // Dynamically find and loop through the rendered project entries.
            const projectEntries = document.querySelectorAll('.project-entry');
            projectEntries.forEach(entry => {
                const index = entry.getAttribute('data-project-index');
                const nameInput = document.getElementById(`project-${index}-name`);
                if (nameInput && nameInput.value.trim()) {
                    const deadlineInput = document.getElementById(`project-${index}-deadline`);
                    const goalInput = document.getElementById(`project-${index}-goal`);
                    // Reconstruct the ID from the name for consistency in the demo.
                    const projectId = `proj-${nameInput.value.toLowerCase().replace(/\s+/g, '-').substring(0, 10)}`;
                    projects.push({
                        id: projectId,
                        name: nameInput.value,
                        deadline: deadlineInput.value,
                        measuredGoal: goalInput.value,
                        linkedValueIds: [],
                        linkedPriorityIds: []
                    });
                }
            });
            appStore.updateCoreProjects(projects);
            this.app.nextStep();
        });
    }
}
